import {formatDateJapanese} from '../../../../../shared/services/formatDate';

export const UpdatedBy: React.FC<{
  updatedAt: string;
}> = ({updatedAt}) => {
  return (
    <div className="mt-16">
      <p className="text-base text-black-2 leading text-right">
        {formatDateJapanese(updatedAt)}更新
      </p>
    </div>
  );
};
